/* unplugin-vue-components disabled */import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, isRef as _isRef, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["src"];
const _hoisted_2 = {
  class: "avatar-upload-preview"
};
const _hoisted_3 = ["src"];
import "vue-cropper/dist/index.css";
import { VueCropper } from "vue-cropper";
import { uploadAvatar } from "@/api/system/user";
import useUserStore from "@/store/modules/user";
export default {
  __name: 'userAvatar',
  setup(__props) {
    const userStore = useUserStore();
    const {
      proxy
    } = getCurrentInstance();
    const open = ref(false);
    const visible = ref(false);
    const title = ref("修改头像");

    //图片裁剪数据
    const options = reactive({
      img: userStore.avatar,
      // 裁剪图片的地址
      autoCrop: true,
      // 是否默认生成截图框
      autoCropWidth: 200,
      // 默认生成截图框宽度
      autoCropHeight: 200,
      // 默认生成截图框高度
      fixedBox: true,
      // 固定截图框大小 不允许改变
      previews: {} //预览数据
    });

    /** 编辑头像 */
    function editCropper() {
      open.value = true;
    }
    ;

    /** 打开弹出层结束时的回调 */
    function modalOpened() {
      visible.value = true;
    }
    ;

    /** 覆盖默认上传行为 */
    function requestUpload() {}
    ;

    /** 向左旋转 */
    function rotateLeft() {
      proxy.$refs.cropper.rotateLeft();
    }
    ;

    /** 向右旋转 */
    function rotateRight() {
      proxy.$refs.cropper.rotateRight();
    }
    ;

    /** 图片缩放 */
    function changeScale(num) {
      num = num || 1;
      proxy.$refs.cropper.changeScale(num);
    }
    ;

    /** 上传预处理 */
    function beforeUpload(file) {
      if (file.type.indexOf("image/") == -1) {
        proxy.$modal.msgError("文件格式错误，请上传图片类型,如：JPG，PNG后缀的文件。");
      } else {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          options.img = reader.result;
        };
      }
    }
    ;

    /** 上传图片 */
    function uploadImg() {
      proxy.$refs.cropper.getCropBlob(data => {
        let formData = new FormData();
        formData.append("avatarfile", data);
        uploadAvatar(formData).then(response => {
          open.value = false;
          options.img = process.env.VUE_APP_BASE_API + response.imgUrl;
          userStore.avatar = options.img;
          proxy.$modal.msgSuccess("修改成功");
          visible.value = false;
        });
      });
    }
    ;

    /** 实时预览 */
    function realTime(data) {
      options.previews = data;
    }
    ;

    /** 关闭窗口 */
    function closeDialog() {
      options.img = userStore.avatar;
      options.visible = false;
    }
    ;
    return (_ctx, _cache) => {
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_row = _resolveComponent("el-row");
      const _component_Upload = _resolveComponent("Upload");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_upload = _resolveComponent("el-upload");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
        class: "user-info-head",
        onClick: _cache[0] || (_cache[0] = $event => editCropper())
      }, [_createElementVNode("img", {
        src: _unref(options).img,
        class: "img-circle img-lg",
        title: "点击上传头像"
      }, null, 8, _hoisted_1)]), _createVNode(_component_el_dialog, {
        modelValue: _unref(open),
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _isRef(open) ? open.value = $event : null),
        title: _unref(title),
        "close-on-click-modal": false,
        "append-to-body": "",
        width: "80rem",
        onBeforeClose: closeDialog,
        onOpened: modalOpened,
        draggable: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            md: 12,
            style: {
              height: '35rem'
            },
            xs: 24
          }, {
            default: _withCtx(() => [_unref(visible) ? (_openBlock(), _createBlock(_unref(VueCropper), {
              key: 0,
              ref: "cropper",
              autoCrop: _unref(options).autoCrop,
              autoCropHeight: _unref(options).autoCropHeight,
              autoCropWidth: _unref(options).autoCropWidth,
              fixedBox: _unref(options).fixedBox,
              img: _unref(options).img,
              info: true,
              onRealTime: realTime
            }, null, 8, ["autoCrop", "autoCropHeight", "autoCropWidth", "fixedBox", "img"])) : _createCommentVNode("", true)]),
            _: 1
          }), _createVNode(_component_el_col, {
            md: 12,
            style: {
              height: '35rem'
            },
            xs: 24
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
              src: _unref(options).previews.url,
              style: _normalizeStyle(_unref(options).previews.img)
            }, null, 12, _hoisted_3)])]),
            _: 1
          })]),
          _: 1
        }), _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)), _createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            lg: 2,
            md: 2
          }, {
            default: _withCtx(() => [_createVNode(_component_el_upload, {
              "before-upload": beforeUpload,
              "http-request": requestUpload,
              "show-file-list": false,
              action: "#"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_button, null, {
                default: _withCtx(() => [_cache[7] || (_cache[7] = _createTextVNode(" 选择 ", -1)), _createVNode(_component_el_icon, {
                  class: "el-icon--right"
                }, {
                  default: _withCtx(() => [_createVNode(_component_Upload)]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            lg: {
              span: 1,
              offset: 2
            },
            md: 2
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              icon: "Plus",
              onClick: _cache[1] || (_cache[1] = $event => changeScale(1))
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            lg: {
              span: 1,
              offset: 1
            },
            md: 2
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              icon: "Minus",
              onClick: _cache[2] || (_cache[2] = $event => changeScale(-1))
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            lg: {
              span: 1,
              offset: 1
            },
            md: 2
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              icon: "RefreshLeft",
              onClick: _cache[3] || (_cache[3] = $event => rotateLeft())
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            lg: {
              span: 1,
              offset: 1
            },
            md: 2
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              icon: "RefreshRight",
              onClick: _cache[4] || (_cache[4] = $event => rotateRight())
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            lg: {
              span: 2,
              offset: 6
            },
            md: 2
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[5] || (_cache[5] = $event => uploadImg())
            }, {
              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode("提 交", -1)]))]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue", "title"])], 64);
    };
  }
};